// Images
import successStory1 from "../assets/images/img-success-story-the-economist.jpg";
import successStory2 from "../assets/images/img-success-story-tendo.png";

const workSuccessStoriesData = [
  {
    image: successStory1,
    client: {
      title: "The client",
      name: "The Economist Newspaper",
      text: "A world-renowned brand since 1843.",
    },
    challenge: {
      title: "The challenge",
      name: "A ground up rebuild of a high profile web frontend",
      text: "A previous attempt to replace the legacy website with a single page app had left a precarious pile of tech debt. We were faced with the decision to work through the problems or start from scratch.",
    },
    solution: {
      title: "Our solution",
      name: "A performant Next.js app and the start of a new team",
      text: "We developed and deployed a new frontend to production where it now successfully serves tens of millions of visitors a month. Alongside this we helped to improve the hiring process and recruit for a new permanent team.",
    },
    quote: {
      text: "orangejellyfish came into The Economist and assessed the current state of engineering and product development. In a short time, the team presented a compelling case to ground up rebuild the website, as the fastest way to get the foundations in place for a new digital product platform. Augmenting existing engineers, the team gave The Economist the room to replatform progressively feature by feature, and worked tirelessly to sunset the now legacy platform.",
      author: "John Wards - Head of Software Engineering",
    },
    url: {
      link: "https://www.economist.com",
      title: "ECONOMIST.COM",
    },
  },
];

// Needs updating with MindStep info
const startUpSuccessStoriesData = [
  {
    image: successStory2,
    client: {
      title: "The client",
      name: "Tendo",
      text: "Skills Wallet for Frontline Workers",
    },
    challenge: {
      title: "The challenge",
      name: "Develop a system to allow capture and recognition of skills",
      text: "",
    },
    solution: {
      title: "Our solution",
      name: "A scalable, Serverless backend on AWS with a React frontend",
      text: "",
    },
    quote: {
      text: "Orange Jellyfish worked with Tendo from the very beginning - testing out ideas and helping us really understand what the problem was we were trying to solve. Eventually after testing many ideas and prototypes they architected and built a lightweight system that we are now starting to onboard users on. Best of all, because it's Serverless it's costing virtually nothing but ready to scale",
      author: "Will Ross - CEO Tendo",
    },
    url: {
      link: "https://www.tendo.id",
      title: "TENDO.ID",
    },
  },
];

export {
  workSuccessStoriesData,
  startUpSuccessStoriesData,
};
